export const authHttp = (
    apiUrl: string,
    apiEndpoint: string,
    httpClient: any,
    successCallback?: any,
    errorCallback?: any,
) => {
    httpClient(`${apiUrl}/${apiEndpoint}`, {
        method: 'POST',
    })
        .then(() => {
            successCallback && successCallback();
        })
        .catch((error: any) => {
            console.error('Error during logout:', error);
            errorCallback && errorCallback(error);
        });
};
